/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getList({ commit }, { teacher_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`teacher/${teacher_id}/schedules?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetail({ commit }, { teacher_id, schedule_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `teacher/${teacher_id}/schedule/${schedule_id}?${new URLSearchParams(
            query,
          )}`,
        )
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setFilters({ commit }, data) {
    commit("SET_FILTERS", data);
  },
  getEnrollmentCourses({ commit }, { teacher_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`teacher/${teacher_id}/courses?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_COURSES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getEnrollmentCoursesClass({ commit }, { teacher_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`teacher/${teacher_id}/classes?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_CLASSES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
